import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as Icon } from 'assets/Icons/24px/cam-app.svg';

function CamAppIcon(props: SvgIconProps) {
  return (
    <SvgIcon component={Icon} viewBox="0 0 24 24"{...props} style={{fill:'none'}} />
  );
}

export default CamAppIcon;